module.exports = __webpack_public_path__ + "img/nike-red.ead3977b.jpg";